export enum MediaType {
    APPLICATION_FORM_URLENCODED = 'application/x-www-form-urlencoded',
    APPLICATION_JSON = 'application/json',
    IMAGE_PNG = 'image/png'
}